enum NounPosition {
  Subject,
  Object
}

export default NounPosition
